import { CopyOutlined, StarFilled } from "@ant-design/icons"
import { Button, Popover, Tag, message } from "antd"
import { useState } from "react"
import { useLocation } from "react-router-dom"
import { useAuthContext } from "../context/AuthContext"
import { useAuthStore } from "../stores/AuthStore"
import { environmentType } from "../types/environtment"

type Props = {
  env: environmentType
}

export const EnvStatus = ({ env }: Props) => {
  const {
    user,
    token,
    env: environtment,
    setRedirect,
    handleWorkosLogout,
  } = useAuthContext()
  const { isAuthenticated, setEnv } = useAuthStore()
  const [open, setOpen] = useState(false)
  const location = useLocation()

  const handleLogoutCheck = () => {
    handleWorkosLogout({})
  }

  return user[env] ? (
    <Popover
      open={open}
      onOpenChange={(value) => setOpen(value)}
      placement="topRight"
      trigger="click"
      content={
        <>
          <Button
            style={{ marginRight: "5px" }}
            size="small"
            icon={<CopyOutlined />}
            onClick={() => {
              navigator.clipboard.writeText(token[env] || "")
              message.success("Text copied to clipboard")
            }}
          >
            Copy JWT
          </Button>
          <Button
            style={{ marginRight: "5px" }}
            size="small"
            icon={<CopyOutlined />}
            onClick={() => {
              navigator.clipboard.writeText(user.dev?.uid || "")
              message.success("ID copied to clipboard")
            }}
          >
            Copy My ID
          </Button>
          <Button
            size="small"
            type="primary"
            danger
            onClick={() => {
              setOpen(false)
              handleLogoutCheck()
            }}
          >
            Log Out
          </Button>
        </>
      }
    >
      <Tag
        key={env}
        style={{
          color: "white",
          background: isAuthenticated[env] ? "#424bd1" : "#D14242",
          cursor: "pointer",
        }}
        onClick={() => setEnv(env)}
      >
        {env === environtment && <StarFilled />}
        <span>{env}</span>
      </Tag>
    </Popover>
  ) : (
    <Tag
      key={env}
      style={{
        color: "white",
        background: isAuthenticated[env] ? "#424bd1" : "#D14242",
        cursor: "pointer",
      }}
      onClick={() => {
        setOpen(false)
        setRedirect(location.pathname)
        setEnv(env)
      }}
    >
      {env === environtment && <StarFilled />}
      <span>{env}</span>
    </Tag>
  )
}
